import React from 'react';
import s from './spacing-component.module.scss';

// Doing array and getting the item types from it so we can assert in the tests that the types are correct and not allow any other values
export const AVAILABLE_SPACING = Object.freeze([
	0,
	6,
	12,
	25,
	50,
	75,
	100,
	150,
	200,
	250,
	300,
	400,
	500,
	600,
	1000
] as const);
export type DSSpacingSize = typeof AVAILABLE_SPACING[number];

export function DSSpacing({ size }: { size: DSSpacingSize }) {
	if (size === 0) {
		return null;
	}
	return <span className={s.space} style={{ width: `var(--ds-spacing-${size})` }}></span>;
}
